var map = {
	"./accessRequest.svg": "./src/app/views/Keno/Icons/accessRequest.svg",
	"./clock.svg": "./src/app/views/Keno/Icons/clock.svg",
	"./configuration.svg": "./src/app/views/Keno/Icons/configuration.svg",
	"./dashboard.svg": "./src/app/views/Keno/Icons/dashboard.svg",
	"./help.svg": "./src/app/views/Keno/Icons/help.svg",
	"./logout.svg": "./src/app/views/Keno/Icons/logout.svg",
	"./savings.svg": "./src/app/views/Keno/Icons/savings.svg",
	"./settings.svg": "./src/app/views/Keno/Icons/settings.svg",
	"./statistics.svg": "./src/app/views/Keno/Icons/statistics.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/app/views/Keno/Icons sync recursive ^\\.\\/.*\\.svg$";